import { action, makeObservable, observable, override } from 'mobx'

import { ShopRootStore } from 'shop/stores/shopRoot.store'

import SharedStore from 'shared/stores/shared.store'

import {
  CookiesConsents,
  CookiesConsentsApi,
  createCookiesConsentsApi,
  CookiesConsentsApiParams,
} from '../api/cookiesConsents.api'

export class CookiesConsentsStore extends SharedStore<CookiesConsents> {
  storeName = 'CookiesConsentsStore'
  declare childApi: CookiesConsentsApi

  @observable acceptedCookieConsents = ''

  constructor(root: ShopRootStore) {
    super()
    this.childApi = createCookiesConsentsApi(root.apiClientV2)
    makeObservable(this)
  }

  @action setAcceptedCookieConsents = (consents: string): void => {
    this.acceptedCookieConsents = consents
  }

  @override
  async fetchList(params: CookiesConsentsApiParams): Promise<void> {
    if (this.list.length) {
      return
    }
    const { data } = await this.childApi.fetchList(params)
    this.list = data
  }
}
